// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  clientId: 'a558af263b1b2e9ce5686737060ea20a',
  clientSecret: '303e09a7dfa1f74e71267fc6c3410fea750f627b2e9f710f0de896b6f8371879',
  jdoodle_baseUrl: "https://api.jdoodle.com/v1/execute",
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
